// src/events/webSocketHandlers.ts
import type { ChatMessageEvent } from './types';

let chatMessageCallbacks: ((data: ChatMessageEvent) => void)[] = [];
let processEventCallbacks: ((eventName: string, data: ProcessEventData) => void)[] = [];

export interface ProcessEventData {
  process_id: string;
  status: 'success' | 'error' | 'uploaded';
  message?: string;
}

export const registerChatMessageCallback = (callback: (data: ChatMessageEvent) => void): void => {
  chatMessageCallbacks.push(callback);
};

export const unregisterChatMessageCallback = (callback: (data: ChatMessageEvent) => void): void => {
  chatMessageCallbacks = chatMessageCallbacks.filter((cb) => cb !== callback);
};

export const registerProcessEventCallback = (
  callback: (eventName: string, data: ProcessEventData) => void
): void => {
  processEventCallbacks.push(callback);
};

export const unregisterProcessEventCallback = (): void => {
  processEventCallbacks = [];
};

export const handleWebSocketEvent = (eventName: string, data: unknown): void => {
  if (eventName === 'chat-message' && chatMessageCallbacks.length > 0) {
    chatMessageCallbacks.forEach((cb) => cb(data as ChatMessageEvent));
  }
  if (eventName.startsWith('process-') && processEventCallbacks.length > 0) {
    processEventCallbacks.forEach((cb) => cb(eventName, data as ProcessEventData));
  }
};
